import React from 'react'
import PropTypes from 'prop-types'
import ClassNames from 'classnames'

import Typography from 'components/atoms/Typography'
import LinkHandler from 'components/atoms/LinkHandler'

import './Banner.scss'

function Banner({ className, children, link, title, theme }) {
  const BannerComponent = () => (
    <div
      className={ClassNames('banner p-3 p-lg-4 card', className, {
        [`card-${theme}`]: theme,
        'banner--no-link': link && !link.url,
      })}
    >
      {title && (
        <Typography cssClass="title-bold-md mb-5" color="white">
          {title}
        </Typography>
      )}
      {children}
      {(link?.url || link?.title) && (
        <div className="mr-1 mt-5 d-flex align-items-center">
          {link && <i className="icone-arrow-down icon mr-3" role="presentation" />}
          <Typography>{link.title}</Typography>
        </div>
      )}
    </div>
  )
  if (link?.url) {
    return (
      <LinkHandler className="d-flex h-100" to={link?.url}>
        <BannerComponent />
      </LinkHandler>
    )
  }

  return (
    <div className="d-flex h-100">
      <BannerComponent />
    </div>
  )
}

Banner.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  link: PropTypes.exact({
    url: PropTypes.string,
    title: PropTypes.string,
  }),
  theme: PropTypes.string,
  title: PropTypes.string,
}

export default Banner
